import React,{useState} from 'react'
import Canvas from "../canvas/Canvas"

import thumb24 from '../images/thumb_24.jpg';
import thumb25 from '../images/thumb_25.jpg';

import img24 from '../images/24.png';
import img25 from '../images/25.png';


import {Modal} from 'react-bootstrap';
import "./modal.css";

export default function Vitreous(){
    const [show,setShow] = useState(false);
    const [title,setTitle] = useState("Eye Lids");
    const [showImage,setShowImage] = useState(img24);
 
    const handleShow = (subtitle,imagename)=>{
         setTitle(subtitle)
         setShowImage(imagename)
         setShow(true)
    }
    return(
        <>
           <div className="card card-custom gutter-b">
                <div className="card-header">
                    <div className="card-title">
                        <h3 className="card-lable">
                            Vitreous
                        </h3>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">

                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img  alt="excimage"  src={thumb24}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Detachment 1</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Vitreous- Detachment 1",img24)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb25}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Detachment 2</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Vitreous - Detachment 2",img25)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        



                    </div>
                </div>
            </div>  
            <Modal
                show={show}
                size="lg"
                onHide={()=>setShow(false)}
                dialogClassName="modal-90w"
                >
                    <Modal.Header closeButton>
                      
                        <Modal.Title>
                            Eye Draw - {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>     
                      {/*   <Image src={img1} fluid />*/}
                      <div style={{height:"70vh",width:"60vw"}}>
                      <Canvas image={showImage} />
                      </div>
                     
                    </Modal.Body>
                </Modal>           
        </>
    )
}